import * as React from 'react';
// can probably take this out and put it somewhere else, khair
const StylishInput = ({ label, type, register, error }) => (
  <div className="relative">
    <input
      type={type}
      {...register}
      placeholder={label}
      autoComplete="true"
      className={`peer w-full rounded-lg border-2 px-4 pt-6 pb-2 text-gray-900 placeholder-transparent placeholder:select-none focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm transition ${
        error ? "border-red-500" : "border-gray-300"
      }`}
      id={label}
    />
    <label
      htmlFor={label}
      className="absolute left-3 top-[5px] cursor-text text-gray-500 text-sm transition-all peer-placeholder-shown:top-4 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-base peer-focus:top-[5px] peer-focus:text-indigo-500 peer-focus:text-sm"
    >
      {label}
    </label>
    {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
  </div>
);

export default StylishInput;
